import React from 'react';
import { Modal } from 'antd';
import getPopupContainer from '../../Hooks/getPopupContainer';
import { ModalProps as ModalCopyProps } from 'antd/lib/modal';

export type ModalProps = ModalCopyProps;

const ProModal: React.FC<ModalProps & {visible?: boolean}> = props => {
  const { children, visible, open, ...resProps } = props;
  return (
    <Modal
      getContainer={getPopupContainer()}
      open={visible || open}
      cancelText='取消'
      okText='确定'
      {...resProps}
    >
      {children}
    </Modal>
  );
};

export default ProModal;
